"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalOptions = exports.elements = void 0;
const store_1 = require("svelte/store");
const easing_1 = require("svelte/easing");
exports.elements = (0, store_1.writable)([]);
exports.globalOptions = (0, store_1.writable)({
    offset: 0,
    duration: 500,
    easing: easing_1.cubicInOut
});
